  export function smartIconValidator(value: string) : boolean {
    // The value must match one of these strings
    return ['icon', 'label'].includes(value);
  };